export const primaryColor = "#00d1d1 ";
export const secondaryColor = "#101011";
export const textWithWhiteBg = "#101011";
export const textWithPrimaryColorBg = "#101011";
export const linearGradient =
  "linear-gradient(108deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 32.59%, rgba(0, 209, 209, 0.60) 69.51%, rgba(0, 209, 209, 0.60) 110.44%)";
